/*
  Zoeken vanuit de kopbalk en vanuit de zoekblokken in de tekst.

  WAT DIT DOET
  Tijdens het typen worden de best passende vragen getoond. Klikken op een suggestie gaat
  naar de FAQ met de handle van die vraag als anker, waarna `ibb-faq.js` die vraag opent.
  Op enter drukken stuurt naar de FAQ met ?q= in de URL; daar draait de volledige zoekactie,
  die ook de antwoorden doorzoekt en bij nul resultaten het vraagformulier toont.

  WAAROM DE LOGICA HIER OPNIEUW STAAT
  De rangschikking is dezelfde als in `ibb-faq.js`: geplooide tekst, tweerichtingsvergelijking
  op woordbegin, zeldzaamheidsweging en een dekkingsdrempel. Ze staat hier opnieuw en niet in
  een gedeeld bestand, omdat de FAQ-pagina met DOM-rijen werkt en dit met een JSON-lijst.
  Wie aan de ene sleutelt, moet naar de andere kijken.

  ZONDER JAVASCRIPT
  Het veld zit in een echt formulier met method=get naar de FAQ, dus enter werkt ook als dit
  bestand niet laadt. Enkel de suggesties vallen dan weg.
*/
(function () {
  var STOP = {
    nl: 'de het een en of van voor met is zijn heb heeft hoe wat waar wanneer waarom wie welke moet mag kan kun kunt je jij ik we wij mijn mij hij ze zij u uw dat die dit deze er te aan op in bij om als dan ook nog al niet geen maar toch wel naar door over onder tot uit veel meer echt eigenlijk zo eens even wordt worden word',
    en: 'the a an and or of for with is are was do does did how what where when why who which should can could would you your yours i my me we our it its this that there to at in on by as if then also not no but very more much really so just',
    fr: 'le la les un une des du de et ou pour avec est sont comment quoi que qui quel quelle quels quelles quand pourquoi je tu il elle on nous vous ils elles mon ma mes ton votre ce cet cette ces au aux en dans sur par si alors aussi ne pas plus tres bien vraiment donc',
    it: 'il lo la i gli le un uno una del della di e ed o per con sono come cosa che chi quale quali quando perche io tu lui lei noi voi loro mio mia miei tuo suo questo questa questi queste al ai alla in su da se allora anche non piu molto davvero quindi'
  };

  function fold(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function hit(list, t) {
    for (var i = 0; i < list.length; i++) {
      var w = list[i];
      if (w === t) return 2;
      if (t.length >= 4 && w.length > t.length && w.indexOf(t) === 0) return 1;
      if (w.length >= 4 && t.length > w.length && t.indexOf(w) === 0) return 1;
    }
    return 0;
  }

  var cache = null;

  function index() {
    if (cache) return cache;
    cache = [];
    var src = document.querySelector('[data-ibb-faq-index]');
    if (!src) return cache;
    var raw = [];
    try {
      raw = JSON.parse(src.textContent) || [];
    } catch (e) {
      raw = [];
    }
    cache = raw.map(function (it, i) {
      return {
        h: it.h,
        q: it.q,
        order: i,
        qt: fold(it.q).split(' '),
        kt: fold(it.k || '').split(' '),
        qs: fold(it.q)
      };
    });
    return cache;
  }

  function rank(list, raw, locale, max) {
    var folded = fold(raw);
    if (!folded) return [];

    var stop = (STOP[locale] || STOP.nl).split(' ');
    var tokens = folded.split(' ').filter(function (t) {
      return t.length > 1 && stop.indexOf(t) === -1;
    });
    if (!tokens.length) tokens = folded.split(' ').filter(Boolean);
    if (!tokens.length) return [];

    var N = list.length;
    if (!N) return [];

    var maxW = 0;
    var weight = tokens.map(function (t) {
      var df = 0;
      for (var i = 0; i < N; i++) {
        if (hit(list[i].qt, t) || hit(list[i].kt, t)) df++;
      }
      var w = Math.log((N + 1) / (df + 1)) + 0.1;
      maxW += w;
      return { t: t, w: w };
    });
    var need = tokens.length === 1 ? 0 : maxW * 0.5;

    var found = [];
    list.forEach(function (it) {
      var score = 0;
      var cov = 0;
      weight.forEach(function (tw) {
        var h = hit(it.qt, tw.t) * 3 + hit(it.kt, tw.t) * 2;
        if (h) {
          score += h * tw.w;
          cov += tw.w;
        }
      });
      if (score > 0 && it.qs.indexOf(folded) !== -1) {
        score += 30;
        cov = maxW;
      }
      if (score > 0 && cov >= need) found.push({ it: it, s: score });
    });

    if (found.length) {
      var best = 0;
      found.forEach(function (f) {
        if (f.s > best) best = f.s;
      });
      found = found.filter(function (f) {
        return f.s >= best * 0.34;
      });
    }

    found.sort(function (a, b) {
      return b.s - a.s || a.it.order - b.it.order;
    });
    return found.slice(0, max || 6);
  }

  function setup(wrap) {
    if (wrap.hasAttribute('data-ibb-hzoek-ready')) return;
    wrap.setAttribute('data-ibb-hzoek-ready', '1');

    var inline = wrap.hasAttribute('data-inline');
    var btn = wrap.querySelector('[data-ibb-hzoek-btn]');
    var panel = wrap.querySelector('[data-ibb-hzoek-panel]');
    var input = wrap.querySelector('[data-ibb-hzoek-input]');
    var list = wrap.querySelector('[data-ibb-hzoek-list]');
    var none = wrap.querySelector('[data-ibb-hzoek-none]');
    var form = wrap.querySelector('form');
    if (!input || !list) return;

    var faq = wrap.getAttribute('data-faq-url') || '/pages/faq';
    var locale = wrap.getAttribute('data-locale') || 'nl';
    var txtNone = wrap.getAttribute('data-none') || '';
    var links = [];
    var cur = -1;

    function open() {
      if (inline || !panel) return;
      panel.hidden = false;
      if (btn) btn.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () {
        input.focus();
      }, 20);
    }

    function close() {
      if (inline || !panel) return;
      panel.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    function mark(i) {
      cur = i;
      links.forEach(function (a, n) {
        if (n === i) a.setAttribute('data-current', '1');
        else a.removeAttribute('data-current');
      });
    }

    function suggest() {
      var raw = input.value.trim();
      while (list.firstChild) list.removeChild(list.firstChild);
      links = [];
      cur = -1;

      if (raw.length < 2) {
        if (none) none.hidden = true;
        return;
      }

      var found = rank(index(), raw, locale, 6);
      found.forEach(function (f) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'ibb-hzoek__hit';
        a.href = faq + '#' + f.it.h;
        a.textContent = f.it.q;
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });

      if (none) {
        none.textContent = txtNone;
        none.hidden = found.length > 0 || txtNone === '';
      }
    }

    input.addEventListener('input', suggest);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && links.length) {
        e.preventDefault();
        mark(cur + 1 >= links.length ? 0 : cur + 1);
      } else if (e.key === 'ArrowUp' && links.length) {
        e.preventDefault();
        mark(cur - 1 < 0 ? links.length - 1 : cur - 1);
      } else if (e.key === 'Enter') {
        if (cur >= 0 && links[cur]) {
          e.preventDefault();
          go(links[cur].getAttribute('href'));
        }
      } else if (e.key === 'Escape') {
        if (input.value) {
          input.value = '';
          suggest();
        } else {
          close();
        }
      }
    });

    list.addEventListener('click', function (e) {
      // Wie bewust in een nieuw tabblad wil openen, laten we met rust.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      e.preventDefault();
      go(a.getAttribute('href'));
    });

    function go(href) {
      var here = window.location.pathname;
      var pad = href.split('#')[0];
      if (pad === here) {
        window.location.hash = href.split('#')[1] || '';
        close();
      } else {
        window.location.href = href;
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var raw = input.value.trim();
        if (!raw) {
          e.preventDefault();
          return;
        }
        if (window.location.pathname === faq) {
          e.preventDefault();
          window.location.href = faq + '?q=' + encodeURIComponent(raw);
        }
      });
    }

    if (btn && panel) {
      btn.addEventListener('click', function () {
        if (panel.hidden) open();
        else close();
      });
      document.addEventListener('click', function (e) {
        if (panel.hidden) return;
        if (wrap.contains(e.target)) return;
        close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) close();
      });
    }
  }

  function init() {
    [].slice.call(document.querySelectorAll('[data-ibb-hzoek]')).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
